import { Component, OnInit, OnChanges, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { PlanSummary } from '../models/plan-summary';
import { PlanSummariesByLineOfCoverage } from '../models/plan-summaries-by-loc';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CoreApiService } from 'src/app/services/core-api.service';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../services/utils.service';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { PlanDetailsModalComponent } from '../plan-details-modal/plan-details-modal.component';
import { VoluntaryCarriers } from "../models/voluntarycarriers";
import { MatRadioChange } from '@angular/material/radio';

@Component({
    selector: 'app-plan-card-group',
    templateUrl: './plan-card-group.component.html',
    styleUrls: ['./plan-card-group.component.scss']
})
export class PlanCardGroupComponent implements OnInit, OnChanges {

    _planSummaries: PlanSummariesByLineOfCoverage;
    _planCardComponent: PlanCardComponent;
    _voluntaryCarriers: VoluntaryCarriers[] = [];
    _selectedCarrierName: string = null;
    _showPlanGrid: boolean = false;
    eventFromPlanCardGroupComponent;

    @Output('selected') selectedEmitter = new EventEmitter<PlanSummary[]>();
  

    isLoading: boolean = true;
    private _baseColumns: string[] = ['select', 'carrier', 'name', 'type'];
    private additionalColumns = {
        'Medical': ['premium', 'deductible'],
        'Dental': ['premium', 'deductible', 'maximum'],
        'Vision': [],
        'Life': [],
        'Disability': []
    };
   
    @Input()
    set planSummaries(planSummaries: PlanSummariesByLineOfCoverage) {
        this._planSummaries = planSummaries;
        if (typeof planSummaries === 'undefined') {
            return;
        }
        this._planSummaries.selectedPlanSummaries.forEach(ps => {
            if (ps.isSelected) {
                this.selection.select(ps);
            }
        });
       
        this._planSummaries.selectedPlanSummaries.forEach(ps => {
            if (ps.carrier != null && this._voluntaryCarriers != null && !this._voluntaryCarriers.some(c => c.code === ps.carrier.code)) {

                var vCarrier: VoluntaryCarriers = {
                    code: ps.carrier.code,
                    name: ps.carrier.name,
                    selectedCarrierLogoUrl: ps.carrierLogoUrl,
                    isCarrierSelected: false
                    //TODO :Revisit isCarrierSelected as this logic will not work and point carrier logo to salesforce
                }
                this._voluntaryCarriers.push(vCarrier);
            }
        });

       this._planSummaries.selectedPlanSummaries.forEach(ps => {
            if (ps.isSelected) {
                let voluntaryCarrier: VoluntaryCarriers = this._voluntaryCarriers.find(x => x.code === ps.carrier.code);
                if (typeof voluntaryCarrier === 'undefined') {
                    return;
                } else {
                    voluntaryCarrier.isCarrierSelected = ps.isSelected;
                }
            }
        });

        this._planSummaries.offlinePlanSummaries.forEach(ps => {
            if (ps.isSelected) {
                this.selection.select(ps);
            }
        });
        
        this.selectedEmitter.emit(this.selection.selected);
    }

    
    LoC: string;
    selectedValue: string = '';

    // Refactor thought: This might be changed to an @Input and fed in
    LoCDescriptions = {
        'Medical': 'DESCRIPTION FOR MEDICAL GOES HERE',
        'Dental': 'DESCRIPTION FOR DENTAL GOES HERE',
        'Vision': 'DESCRIPTION FOR VISION GOES HERE',
        'Life': 'DESCRIPTION FOR LIFE GOES HERE',
        'Disability': 'DESCRIPTION FOR DISABILITY GOES HERE',

    };

    // [0] is the selectedBenefits key, [1] is the search-for string
    private selectedBenefitsKeys = [
        ['deductible', 'Deductible'],
        ['maximum', 'Annual Maximum']
    ];

    selection: SelectionModel<PlanSummary> = new SelectionModel<PlanSummary>(true, []);

    displayedColumns: string[] = [];
    
    get columnFilterOptions() {
        const cols = this.displayedColumns.slice(1);
        cols.forEach((c) => c = c[0].toUpperCase() + c.substring(1));
        return cols;
    }
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    isAnySelected() {
        return this.selection.selected.length > 0;
    }

    anyPlanSelected() {
        var planCount = this.selection.selected.length;
        if (planCount > 0) {
            this.carrierToSelect = this.selection.selected[0].carrier.code;
        }
    }

    
    dataSource: MatTableDataSource<PlanSummary>;
    filteredDataSource: MatTableDataSource<PlanSummary>;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    message: string;
    carrierToSelect: string;

    constructor(private api: CoreApiService, private route: ActivatedRoute, public dialog: MatDialog, public utils: Utils) { }

    openPlanModal(plan: PlanSummary) {
        console.log('plan', plan);
        this.scrollToCenter();
        const dialogRef = this.dialog.open(PlanDetailsModalComponent, { data: { plan: plan, selections: this.selection } });
    }

    private get planSummaryData() {
        let data: PlanSummary[] = [];
        if (this._planSummaries) {
            const selPlans = this._planSummaries.selectedPlanSummaries;
            if (selPlans && selPlans.length > 0) {
                data = data.concat(selPlans);
            }
            if (this.showOfflinePlans) {
                const offlinePlans = this._planSummaries.offlinePlanSummaries;
                if (offlinePlans && offlinePlans.length > 0) {
                    data = data.concat(offlinePlans);
                }
            }
        }
        return data;
    }

    get hasOfflinePlans() {
        return this._planSummaries && this._planSummaries.offlinePlanSummaries && this._planSummaries.offlinePlanSummaries.length > 0;
    }

    showOfflinePlans = false;
    
    private tableConfigSort() {
        this.dataSource.sort = this.sort;

        // Custom sorting logic to control what the sort is based on for what column
        // will need updated based on benefits for other lines of coverage
        this.dataSource.sortingDataAccessor = (item: any, property: string) => {
            if (property in item.selectedBenefits) {
                return item.selectedBenefits[property][1];
            }
            // the below logic for select works, but the sort overrides the checkbox
            // so I've removed sortability for the select column in the html
            switch (property) {
            case 'carrier': return item.carrier.name;
            case 'select': return this.selection.selected.includes(item);
            case 'type': return item.type;
            default: return item[property];
            }
        };
    }

       private buildSelectedBenefits(ps: PlanSummary) {
        const d: any = {};
        this.selectedBenefitsKeys.forEach(function (sb) {
            const e = ps.benefits.find(b => b.name === sb[1]);
            d[sb[0]] = [['N/A', null]];
            if (e) {
                d[sb[0]][0] = e.inValue;
                d[sb[0]][1] = e.inNumericValue;
            }
        });
        ps.selectedBenefits = d;
    }

    private tableConfigFilter() {
        this.dataSource.filterPredicate = (data: PlanSummary, filter: string) => {

            if (!filter) {
                return true;
            }

            let compareTo = '';
            this.displayedColumns.forEach((col) => {
                if (col in data.selectedBenefits) {
                    // string comparison for filters, as opposed to number comp for sort
                    compareTo += data.selectedBenefits[col][0];
                }
                switch (col) {
                case 'carrier': compareTo += data.carrier.name; compareTo += data.carrier.code; break;
                case 'name': compareTo += data.name; break;
                case 'type': compareTo += data.type; break;
                default: break; // Default is to leave it empty string, as initialized to
                }
            });

            // Remove the currency styling characters from the filter
            compareTo = this.stripCurrencyFormatting(compareTo).toLowerCase();
            return compareTo.includes(filter);
        };

    }

    ngOnInit() {
        this.selection.changed.subscribe((sel) => {
            this.selectedEmitter.emit(this.selection.selected);
        });
        this.anyPlanSelected();
        this.filteredDataSource = this.dataSource;
        this.filterPlansOnLoad();
        
    }

    ngOnChanges() {

       if (this._planSummaries) {
            this.isLoading = false;
            if (this._planSummaries.selectedPlanSummaries) {
                this._planSummaries.selectedPlanSummaries.forEach((p) => { this.buildSelectedBenefits.bind(this)(p); p.isOffline = false; });
            }
            if (this._planSummaries.offlinePlanSummaries) {
                this._planSummaries.offlinePlanSummaries.forEach((p) => { this.buildSelectedBenefits.bind(this)(p); p.isOffline = true; });
            }
        }

        if (this._planSummaries && this._planSummaries.selectedPlanSummaries) {
            this.isLoading = false;
            this.LoC = this._planSummaries.selectedPlanSummaries[0].lineOfCoverage;
        }
        const data = this.planSummaryData;
        if (data && data.length > 0) {
            this.LoC = data[0].lineOfCoverage;

            // pulls out the benefits that'll be displayed on the grid
            //    into their own dictionary, along with relevant sorting value
            this.processTableConfig();

            let toDisplay = this._baseColumns;
            if (this.LoC in this.additionalColumns) {
                toDisplay = toDisplay.concat(this.additionalColumns[this.LoC]);
            }
            if (this.hasOfflinePlans) {
                toDisplay = toDisplay.concat(['offline']);
            }
            this.displayedColumns = toDisplay;
        }
    }

    eventFromPlanCardGroup() {
        return this._selectedCarrierName;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.dataSource.filteredData.forEach(row => this.selection.deselect(row))
            : this.dataSource.filteredData.forEach(row => this.selection.select(row));        
    }

    filterDataSource(carrierName: string) {
        return this.dataSource.data = this.planSummaryData.filter(c => c.carrier.code === carrierName);
    }

    filterPlansOnLoad() {
        if (this.selection.selected.length > 0) {
            var cName = this.selection.selected[0].carrier.code;
            this.filterDataSource(cName);
            this._showPlanGrid = true;
        } 
    }

    onRadioChange($event: MatRadioChange , carrierCode) {
        this._selectedCarrierName = carrierCode;
        this.filterDataSource(this._selectedCarrierName);
        this.selection.clear();
        this.dataSource.filteredData.forEach(row => this.selection.deselect(row));
        this.carrierToSelect = carrierCode;
        this._showPlanGrid = true;
    }

   processTableConfig() {
        this.dataSource = new MatTableDataSource<PlanSummary>(this.planSummaryData);
        this.dataSource.paginator = this.paginator;
        this.tableConfigFilter();
        this.tableConfigSort();
    }

    private stripCurrencyFormatting(t: string): string {
        return t.replace('$', '').replace(',', '');
    }

    filterOffline(isChecked: boolean) {
        this.showOfflinePlans = isChecked;
        const newData = this.planSummaryData;
        this.dataSource.data = newData;

        if (newData.length < this.paginator.pageSize * this.paginator.pageIndex) {
            this.paginator.firstPage();
        }
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = this.stripCurrencyFormatting(filterValue).trim().toLowerCase();
        this.filteredDataSource.filter = this.stripCurrencyFormatting(filterValue).trim().toLowerCase();
    }

    private parseCanvasToken(signedRequest) {
        const win: any = window;
        const part = signedRequest.split('.')[1];
        const decodedToken = win.Sfdc.canvas.decode(part);
        const canvasToken = JSON.parse(decodedToken);
        return canvasToken;
    }

    private getCanvasToken() {
        const win: any = window;
        return new Promise((resolve, reject) => {
            win.Sfdc.canvas.client.refreshSignedRequest((data: any) => {
                if (data.status === 200) {
                    const signedRequest = data.payload.response;
                    const token = this.parseCanvasToken(signedRequest);
                    resolve(token);
                } else {
                    reject(new Error('Error occurred while getting canvas token'));
                }
            });
        });
    }

    // This script will scroll the page to the position where the modal is open.
    scrollToCenter() {
        const win: any = window;
        const sizes = win.Sfdc.canvas.client.size();
        const offSet = 300;
        const top = (sizes.heights.contentHeight / 2) - offSet;
        const args = JSON.stringify({ oeScrollToTop: true, top: top });
        return this.getCanvasToken().then((token: any) => {
            window.top.postMessage(args, token.client.targetOrigin);
        });
    }
}
